export default __webpack_public_path__ + "static/media/remove_icon.8b54a19b.svg";